import { ReactNode, useState } from "react";
import PostgresConnector from "./connectors/postgres-connector";
import MySQLConnector from "./connectors/mysql-connector";
import SnowflakeConnector from "./connectors/snowflake-connector";
import ShopifyConnector from "./connectors/shopify-connector";
import MetabaseConnector from "./connectors/metabase-connector/metabase-connector";

interface DatabaseConnectorProps {
  children: ReactNode;
  databaseName: string;
  key: number;
}

const DatabaseConnector = ({
  children,
  databaseName,
}: DatabaseConnectorProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const getDatabaseColors = () => {
    switch (databaseName.toLowerCase()) {
      case "postgresql":
        return {
          logoHover: "group-hover:bg-blue-100",
          iconHover: "group-hover:text-blue-600",
          buttonHover:
            "group-hover:bg-blue-600 group-hover:border-blue-600 group-hover:text-white",
        };
      case "mysql":
        return {
          logoHover: "group-hover:bg-orange-100",
          iconHover: "group-hover:text-orange-600",
          buttonHover:
            "group-hover:bg-orange-600 group-hover:border-orange-600 group-hover:text-white",
        };
      case "snowflake":
        return {
          logoHover: "group-hover:bg-cyan-100",
          iconHover: "group-hover:text-cyan-600",
          buttonHover:
            "group-hover:bg-cyan-600 group-hover:border-cyan-600 group-hover:text-white",
        };
      case "shopify":
        return {
          logoHover: "group-hover:bg-green-100",
          iconHover: "group-hover:text-green-600",
          buttonHover:
            "group-hover:bg-green-600 group-hover:border-green-600 group-hover:text-white",
        };
      case "metabase":
        return {
          logoHover: "group-hover:bg-violet-100",
          iconHover: "group-hover:text-violet-600",
          buttonHover:
            "group-hover:bg-purple-600 group-hover:border-purple-600 group-hover:text-white",
        };
      default:
        return {
          logoHover: "",
          iconHover: "",
          buttonHover: "",
        };
    }
  };

  const handleConnect = () => {
    if (databaseName.toLowerCase() === "postgresql") {
      setIsDialogOpen(true);
    }
    if (databaseName.toLowerCase() === "mysql") {
      setIsDialogOpen(true);
    }
    if (databaseName.toLowerCase() === "snowflake") {
      setIsDialogOpen(true);
    }
    if (databaseName.toLowerCase() === "shopify") {
      setIsDialogOpen(true);
    }
    if (databaseName.toLowerCase() === "metabase") {
      setIsDialogOpen(true);
    }
  };

  const colors = getDatabaseColors();

  return (
    <>
      <div className="group card card-border">
        <div className="card-body items-center text-center">
          <div
            className={`flex items-center justify-center w-16 h-16 rounded-full mb-2 mx-auto transition-all duration-200 ${colors.logoHover}`}
          >
            <div
              className={`w-8 h-8 transition-all duration-200 ${colors.iconHover} [&>svg]:w-full [&>svg]:h-full`}
            >
              {children}
            </div>
          </div>
          <h3 className="text-lg font-medium text-center mb-4">
            {databaseName}
          </h3>
          <div className="card-actions justify-end w-full">
            <button
              className={`btn btn-soft w-full mt-2 transition-all duration-200 ${colors.buttonHover}`}
              onClick={handleConnect}
            >
              Connect
            </button>
          </div>
        </div>
      </div>

      {databaseName.toLowerCase() === "postgresql" && (
        <PostgresConnector open={isDialogOpen} onOpenChange={setIsDialogOpen} />
      )}
      {databaseName.toLowerCase() === "mysql" && (
        <MySQLConnector open={isDialogOpen} onOpenChange={setIsDialogOpen} />
      )}
      {databaseName.toLowerCase() === "snowflake" && (
        <SnowflakeConnector
          open={isDialogOpen}
          onOpenChange={setIsDialogOpen}
        />
      )}
      {databaseName.toLowerCase() === "shopify" && (
        <ShopifyConnector open={isDialogOpen} onOpenChange={setIsDialogOpen} />
      )}
      {databaseName.toLowerCase() === "metabase" && (
        <MetabaseConnector open={isDialogOpen} onOpenChange={setIsDialogOpen} />
      )}
    </>
  );
};

export default DatabaseConnector;
